import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { UserDetail } from "./types";
import { USER_DETAIL_QUERY_KEY } from "./constants";

/**
 * Hits the admin-specific detail endpoint which includes owned
 * properties / venues / ToS acceptances and Firebase `lastSignInAt`.
 * The plain `GET /api/users/:id` returns a leaner `UserModel` without
 * those relations — acceptable for the app, not for the backoffice.
 * See CLAUDE.md → TD-07 for why we bypass the generated client.
 */
export async function fetchUserDetail(id: string): Promise<UserDetail> {
  return httpClient<UserDetail>(`/api/admin/users/${encodeURIComponent(id)}`);
}

export function useUserDetail(id: string | undefined) {
  return useQuery({
    queryKey: [...USER_DETAIL_QUERY_KEY, id] as const,
    queryFn: () => {
      if (!id) throw new Error("useUserDetail requires an id");
      return fetchUserDetail(id);
    },
    enabled: Boolean(id),
    staleTime: 30_000,
  });
}
